import React, { useState, useEffect } from 'react';
import FilterModal from './FilterModal';
import api from '../services/api';

function Filters() {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterNames, setFilterNames] = useState([]);
  const [deleteFilter, setDeleteFilter] = useState(false);

  useEffect(() => {
    const fetchFilterNames = async () => {
      try {
        const response = await api.get('filter/filter-names/', {
          headers: { Authorization: `Token ${localStorage.getItem('Token')}` },
        });
        setFilterNames(response.data);
      } catch (error) {
        console.error('Error fetching filter names:', error);
      }
    };
    fetchFilterNames();
  }, [showFilterModal, deleteFilter]);

  const toggleFilterModal = () => setShowFilterModal(!showFilterModal);
  const handleButtonClick = () => setShowFilterModal(!showFilterModal);

  const handleDeleteFilter = (index, filter) => {
    api.delete(`filter/delete-filter/?filter_name=${filter.filter_name}`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${localStorage.getItem('Token')}` },
    })
      .then(() => {})
      .catch((error) => console.error('Error:', error));
    setDeleteFilter(true);
  };

  return (
    <div style={{ padding: '24px 28px', boxSizing: 'border-box' }}>
      {/* Page header */}
      <div style={{ background: '#0f172a', borderRadius: 12, padding: '18px 24px', marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 19, fontWeight: 700, color: '#fff' }}>Filters</div>
          <div style={{ fontSize: 12.5, color: '#94a3b8', marginTop: 2 }}>Manage saved filter definitions</div>
        </div>
        <button
          onClick={handleButtonClick}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}
        >
          + Create Filter
        </button>
      </div>

      {/* Table card */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        {filterNames.length === 0 ? (
          <div style={{ padding: '48px 0', textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
            No filters saved yet. Click "Create Filter" to get started.
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['S.No', 'Filter Name', 'Filter Definition', 'Action'].map((h) => (
                    <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontWeight: 700, fontSize: 11.5, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filterNames.map((filter, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #f1f5f9', background: index % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '10px 16px', color: '#64748b', width: 60 }}>{index + 1}</td>
                    <td style={{ padding: '10px 16px', fontWeight: 600, color: '#0f172a' }}>{filter.filter_name}</td>
                    <td style={{ padding: '10px 16px', color: '#475569', maxWidth: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{filter.filter_data}</td>
                    <td style={{ padding: '10px 16px', width: 80 }}>
                      <button
                        onClick={() => handleDeleteFilter(index, filter)}
                        title="Delete filter"
                        style={{ background: '#fff1f2', color: '#f43f5e', border: '1px solid #fecdd3', borderRadius: 6, padding: '5px 10px', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' }}
                      >
                        ✕
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <FilterModal showModal={showFilterModal} setShowModal={setShowFilterModal} />
    </div>
  );
}

export default Filters;
